export default "__VITE_ASSET__CKU$5K2o__"